"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var client_1 = require("@apollo/client");
var react_1 = require("@emotion/react");
var avataaars_1 = __importDefault(require("@gamepark/avataaars"));
var react_redux_1 = require("react-redux");
var GameClientAPI_1 = require("../api/Client/GameClientAPI");
function ChatMessageAuthor(_a) {
    var _b, _c;
    var author = _a.author;
    var players = (0, react_redux_1.useSelector)(function (state) { return state.players; });
    var player = players.find(function (p) { return p.userId === author; });
    var data = (0, client_1.useQuery)(GameClientAPI_1.GET_MESSAGE_AUTHOR, { variables: { id: author }, skip: !!player }).data;
    var avatar = (_b = player === null || player === void 0 ? void 0 : player.avatar) !== null && _b !== void 0 ? _b : data === null || data === void 0 ? void 0 : data.user.avatar;
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(avataaars_1.default, __assign({ style: { width: '48px', height: '48px', position: 'absolute', left: '-3px' }, circle: true }, avatar)), (0, jsx_runtime_1.jsx)("p", __assign({ css: authorCss }, { children: (_c = player === null || player === void 0 ? void 0 : player.name) !== null && _c !== void 0 ? _c : data === null || data === void 0 ? void 0 : data.user.name }))] });
}
exports.default = ChatMessageAuthor;
var authorCss = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: bold;\n  line-height: 1.5;\n  margin: 4px 0 0;\n"], ["\n  font-weight: bold;\n  line-height: 1.5;\n  margin: 4px 0 0;\n"])));
var templateObject_1;
